import React from 'react'

import { Text } from 'components/dataDisplay'

import OrderItemBase from 'compositions/orderItems/OrderItemBase/OrderItemBase'
import OrderProductBase from 'compositions/orderItems/OrderProductBase/OrderProductBase'

import messages from './messages'


type SubscriptionOrderItemProps = {
  className?: string
  data: OrderItems.CandleSubscription
}

const CandleSubscriptionOrderItem: React.FunctionComponent<SubscriptionOrderItemProps> = (props) => {
  const { className, data } = props
  const { price, subscriptionCandle } = data

  return (
    <OrderItemBase className={className} data-testid="orderCandleSubscription">
      <Text style="h9" message={messages.title} />
      <div className="mt-16 flex items-center">
        <Text
          message={messages.text}
          style="p2"
          color="black"
        />
        <Text
          className="ml-24"
          message={price}
          style="t2"
          data-testid="price"
        />
      </div>
      {
        Boolean(subscriptionCandle) && (
          <OrderProductBase
            className="mt-24"
            image={subscriptionCandle.image}
            rebrandImage={subscriptionCandle.rebrandImage}
            data-testid="subscriptionCandle"
          >
            <Text
              className="font-semibold"
              message={subscriptionCandle.brand}
              style="p2"
            />
            <Text
              message={subscriptionCandle.name}
              style="p2"
            />
          </OrderProductBase>
        )
      }
    </OrderItemBase>
  )
}


export default CandleSubscriptionOrderItem
